module.exports = __webpack_public_path__ + "img/mobile_map_lecce.de4e8e96.svg";